/* eslint-disable no-restricted-globals */
import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";


export const AccordionItem = ({ header, text }) => {
    const [active, setActive] = useState(false);
  
    const handleToggle = () => {
      event.preventDefault();
      setActive(!active);
    };
    return (
      <div className="mb-2 w-full rounded-2xl bg-gray-50 p-4
       sm:p-5  lg:px-6 xl:px-8">
        <button
          className={`faq-btn flex w-full items-center gap-2 text-left`}
          onClick={() => handleToggle()}
        >
          <div className=" justify-center rounded-lg bg-primary/5 text-primary dark-bg-white/5">
          <IoIosArrowDown  size={10}  className={`bg-[#e2b760] rounded-full text-white text-xs p-1 h-6 w-6 duration-200 ease-in-out ${
                active ? "rotate-180" : ""
              }`} />
           
          </div>
  
          <div className="w-full">
            <h4 className="mt-1 text-base font-semibold text-gray-700 dark-text-white">
              {header}
            </h4>
          </div>
        </button>
  
        <div
          className={`pl-[62px] duration-200 ease-in-out ${
            active ? "block" : "hidden"
          }`}
        >
          <p className="py-3 text-base leading-relaxed text-gray-600 dark-text-dark-6">
            {text}
          </p>
        </div>
      </div>
    );
  };